import { StudentJobOffersTranslation } from 'locales/de/pages/Jobmarket/studentJobOffers';

const en: StudentJobOffersTranslation = {
  title: 'Job applications',
  drawer: {
    titleCreate: 'Create job application',
    titleEdit: 'Edit job application',
    approveDataPrivacy:
      'I am aware that the data I provide here will be published and can be viewed by all registered company users within the dashboard.',
    phone: 'Phone (optional)'
  },
  dialogs: {
    deleteConfirm: 'Do you really want to delete the job application?'
  },
  alerts: {
    deleteSuccess: 'The job application was deleted.',
    deleteFailed: 'The job application could not be deleted.',
    updateSuccess: 'The job application was successfully processed.',
    updateFailed: 'The job application could not be updated.',
    createSuccess: 'The job application was successfully created',
    createFailed: 'The job application could not be created'
  },
  detailPage: {
    title: 'Job application',
    personalData: 'Personal data',
    moreData: 'More data',
    contactNow: 'Contact now'
  },
  tooltips: {
    charsLeft: 'Number of remaining characters. Maximum 100'
  }
};

export default en;
